import { AppDispatchContext } from "Contexts/AppContext";
import { useContext, useEffect } from "react";
import { useQuery } from "react-query";
import { fetchAPI } from "Utils/Fetch";

export function Init() {
    const dispatch = useContext(AppDispatchContext);
    const { data: profile } = useQuery<any, Error>(
        "profile",
        async () => {
            const response = await fetchAPI("GET", "/me");
            return response.json();
        },
        {
            refetchOnWindowFocus: false,
        }
    );
    useEffect(() => {
        if (profile) {
            dispatch({
                type: "setProfile",
                payload: {
                    profile,
                },
            });
        }
    }, [profile]);
    return (<></>);
}